import { render, staticRenderFns } from "./AiTriageRulesWorkspace.vue?vue&type=template&id=e36b2102&scoped=true&"
import script from "./AiTriageRulesWorkspace.vue?vue&type=script&lang=js&"
export * from "./AiTriageRulesWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./AiTriageRulesWorkspace.vue?vue&type=style&index=0&id=e36b2102&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36b2102",
  null
  
)

export default component.exports